import React from 'react'
import { PageTitle, Paragraph, ParaTitle, Pagination} from "../common";
import './Updates.css';

const Updates_3_47_0 = () => {
  return (
    <div>
      <PageTitle title='3.47.0' />

      <ParaTitle paraTitle='Bug Fixes' />
      <Paragraph paragraph='2025-10-31' />

      {/* <ParaTitle paraTitle='Added:' />
      <ul>
        <li>
          Move users
          <p></p>
        </li>
      </ul> */}

      {/* <ParaTitle paraTitle='Changed:' />
      <ul>
        <li>Reviewer UI Updates
          <p>Implemented User feedback: 
          <p>Update reviewer permissions and let them comment after event has been closed</p>
          <p>Add clear button at the top to close reviews</p>
          <p>Change wording posting comments</p>
          </p>
        </li>
        <li>Approver Selection
          <p>
          Implemented functionality allowing Risk Managers to select specific Approvers for specific events, similar to how Reviewers are assigned. Tasks included:
          <p>Created new assign permissions.</p>
          <p>Built/updated table structure for closing events (merged with events).</p>
          <p>Configured email notifications to only the selected Approvers.</p>
          <p>Enabled functionality to remove Approvers.</p>
          <p>Added reminder capability for Approvers to close events.</p>
          <p>Developed a new Approvers tab.</p>
          </p>
        </li>
        <li>Reviwer Permissions
          <p>
          Users prefer a more strict process instead of giving users the ability to add comments whenever. To keep permissions and expectations consistent, permissions has been reverted to previous state.
          </p>
        </li>
      </ul> */}

      <ParaTitle paraTitle='Removed:' />
      <ul>
        <li>
          Help Desk Ticket Bug Fixes
          <p>.</p>
        </li>
      </ul>
      <Pagination
        pagination={{
          prev: { name: 'Updates: 3.48.0', link: '/updates/3.48.0' },
          next: { name: 'Events Summary', link: '/general/events-summary' }
        }}
      />
    </div>

  )
}

export default Updates_3_47_0;